import React, { useState, useRef } from 'react';
import { CRow, CCol, CTabs, CNav, CNavItem, CNavLink, CTabContent, CTabPane } from '@coreui/react';
import { CChartPie } from '@coreui/react-chartjs';

function createElementFromHTML(htmlString) {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();
  
    // Change this to div.childNodes to support multiple top-level nodes.
    return div.firstChild;
}

const GraphControl = (props) => {
//console.log(props.data)
    var candidateNames = [];
    var candidateVotes = [];
    var candidateNamesParties = [];
    var candidateParties = [];
    var candidateColors = [];
    let [dialogOpen, setDialogOpen] = useState(false);
    let [isLeadership, setIsLeadership] = useState(false);

    var theData = props.data;
    var theCandidates = [];
    var turnoutColors = ['#fcdd89','#998e71'];
    var turnoutDataRaw = props.data.hasOwnProperty('Poll total votes') ? (props.data['Poll total votes'] / props.data['Electors'] * 100).toFixed(2) : props.data.hasOwnProperty('Total Ballots') ? (props.data['Total Ballots'] / props.data['Electors'] * 100).toFixed(2) : 0;
    var turnoutData = [turnoutDataRaw, (100-turnoutDataRaw)]
    var turnoutLabels = ['Voted', 'Did not vote']

    var ridingName;
    if (props && props.data && props.data.hasOwnProperty('Riding Name')) {
        ridingName = props.data['Riding Name'].replace(/\/.*/,'')   
    }
    

    if (theData.hasOwnProperty('Candidates')) {
        theCandidates = JSON.parse(theData['Candidates']);
        for (var i=0;i<theCandidates.length;i++) {
            candidateNames.push(theCandidates[i].name);
            candidateNamesParties.push(theCandidates[i].name+" ("+theCandidates[i].party+")");
            candidateVotes.push(theCandidates[i].votes);
            if (theCandidates[i].party === "Liberal" || theCandidates[i].party === "Ontario Liberal Party") {
                candidateColors.push('#ff0000');
            } else if (theCandidates[i].party === "Conservative") {
                candidateColors.push('#0000ff');
            } else if (theCandidates[i].party === "Progressive Conservative") {
                candidateColors.push('#0000ff');
            } else if (theCandidates[i].party === "United Conservative") {
                candidateColors.push('#0000ff');
            } else if (theCandidates[i].party === "Alberta Party") {
                candidateColors.push('#f8c62e');
            } else if (theCandidates[i].party === "Alberta Independence") {
                candidateColors.push('#000000');                
            } else if (theCandidates[i].party === "Wildrose") {
                candidateColors.push('#800080');
            } else if (theCandidates[i].party === "Evergreen") {
                candidateColors.push('green');                                                
            } else if (theCandidates[i].party === "NDP-New Democratic Party" || theCandidates[i].party === "NDP" || theCandidates[i].party === "N.D.P" || theCandidates[i].party === "N.D.P.") {
                candidateColors.push('#ff7200');
            } else if (theCandidates[i].party === "Bloc Québécois") {
              candidateColors.push('#0b9fd6');
            } else if (theCandidates[i].party.startsWith("Bloc ")) {
                candidateColors.push('#0b9fd6');              
            } else if (theCandidates[i].party === "Canadian Alliance") {
                candidateColors.push('#5ba963');
            } else if (theCandidates[i].party === "Alberta Advantage") {
                candidateColors.push('pink');
            } else if (theCandidates[i].party === "Freedom Conservative") {
                candidateColors.push('#2E2787');
            } else if (theCandidates[i].party === "Ontario Centrist Party") {
                candidateColors.push('#72A4FF');
            } else if (theCandidates[i].party === "Electoral Reform Party") {
                candidateColors.push('#86FF72');
            } else if (theCandidates[i].party === "Ontario Party") {
                candidateColors.push('#0b2b52');                
            } else if (theCandidates[i].party === "New Blue Party") {
                candidateColors.push('#002F9E');                                
            } else if (theCandidates[i].party === "Maverick Party") {
              candidateColors.push('#84ba8a');
            } else if (theCandidates[i].party === "Libertarian") {
              candidateColors.push('#f1b92b');
            } else if (theCandidates[i].party === "Green Party" || theCandidates[i].party === "Ontario Green Party" || theCandidates[i].party === "Green Party of Ontario") {
                candidateColors.push('green');
            } else if (theCandidates[i].party === "Parti Rhinocéros Party") {
              candidateColors.push('#ef0885');
            } else if (theCandidates[i].party === "Marijuana Party") {
              candidateColors.push('#325311');
            } else if (theCandidates[i].party === "Free Party Canada") {
              candidateColors.push('#f5dba5');
            } else if (theCandidates[i].party === "Animal Protection Party") {
              candidateColors.push('#d4fbed');
            } else if (theCandidates[i].party === "VCP") {
              candidateColors.push('yellow');
            } else if (theCandidates[i].party === "Marxist-Leninist") {
              candidateColors.push('#a30000');
            } else if (theCandidates[i].party === "Communist") {
              candidateColors.push('#c47373');
            } else if (theCandidates[i].party === "Social Credit") {
                candidateColors.push('#2b5c12');  
            } else if (theCandidates[i].party === "Marijuana Party") {
                candidateColors.push('#6ded2d');                  
            } else if (theCandidates[i].party === "Christian Heritage Party") {
              candidateColors.push('#7b2548');
            } else if (theCandidates[i].party === "People's Party") {
                candidateColors.push('#800080');
            } else if (theCandidates[i].party === "PPC") {
                candidateColors.push('#800080');
            } else if (theCandidates[i].party === "People's Party - PPC") {
              candidateColors.push('#800080');
            } else if (theCandidates[i].party === "Canadian Economic Party") {
              candidateColors.push('#6aff00');
            } else if (theCandidates[i].party === "Canadians' Choice Party") {
              candidateColors.push('#cb2058');
            } else if (theCandidates[i].party === "Consensus Ontario") {
              candidateColors.push('#29a9e2');
            } else if (theCandidates[i].party === "Cultural Action Party") {
              candidateColors.push('#651a94');
            } else if (theCandidates[i].party === "Cultural Action Party") {
              candidateColors.push('#3b2f75');
            } else if (theCandidates[i].party === "Go Vegan") {
              candidateColors.push('#238300');
            } else if (theCandidates[i].party === "Multicultural Party") {
              candidateColors.push('#bfe50e');
            } else if (theCandidates[i].party === "New People's Choice Party") {
              candidateColors.push('#570878');
            } else if (theCandidates[i].party === "Northern Ontario Party") {
              candidateColors.push('#a2001c');
            } else if (theCandidates[i].party === "Ontario Alliance") {
              candidateColors.push('#5bc0de');
            } else if (theCandidates[i].party === "Ontario Moderate Party") {
              candidateColors.push('#00a9e5');
            } else if (theCandidates[i].party === "Ontario Party") {
              candidateColors.push('#122d54');
            } else if (theCandidates[i].party === "Ontario Social Reform Party") {
              candidateColors.push('#2b2193');
            } else if (theCandidates[i].party === "Party for People with Special Needs") {
              candidateColors.push('#602a35');
            } else if (theCandidates[i].party === "Party of Objective Truth") {
              candidateColors.push('#380039');
            } else if (theCandidates[i].party === "Pauper Party") {
              candidateColors.push('#ffff0d');
            } else if (theCandidates[i].party === "People's Political Party") {
              candidateColors.push('#709ba7');
            } else if (theCandidates[i].party === "Stop Climate Change") {
              candidateColors.push('#1db28d');
            } else if (theCandidates[i].party === "Stop the New Sex-Ed Agenda") {
              candidateColors.push('#dd001e');
            } else if (theCandidates[i].party === "Trillium Party") {
              candidateColors.push('#713b8a');
            } else if (theCandidates[i].party === "Independent") {
                candidateColors.push('#888888');
            } else {
                candidateColors.push('black');
            }
            candidateParties.push(theCandidates[i].party);
        }
    }

    if (theData.hasOwnProperty('rounds')) {
      isLeadership = true;
      var cv = Object.entries(theData['properties'].Rounds[theData['roundnum']].candidate_votes);
      var exhausted = theData['properties'].Rounds[theData['roundnum']].exhausted;
      for (var i=0;i<cv.length;i++) {
          candidateNames.push(cv[i][0]);
          candidateVotes.push(cv[i][1]);
          if (cv[i][0] === "Erin O'Toole") {
              candidateColors.push('#7AB7F5');
          } else if (cv[i][0] === "Leslyn Lewis") {
              candidateColors.push('#8BF571');
          } else if (cv[i][0] === "Peter MacKay") {
              candidateColors.push('#b871f5');
          } else if (cv[i][0] === "Derek Sloan") {
              candidateColors.push('#F571D8');
          } else {
              candidateColors.push('black');
          }
          //candidateParties.push(theData['Candidates'][i].party);
      }
    }

    return(
        <div>
            <div>
            { !dialogOpen ? 
                <button style={{width:'100%', height:'50px', padding:'5px'}} onClick={() => setDialogOpen(true)}>
                    <div style={{display:'table', minWidth:'150px'}}>
                        
                            <div style={{display:'table-cell', verticalAlign:'middle', width:'200px'}}>
                                {props && props.data && props.data['Riding Name'] ? ridingName ? ridingName : "" : ""}
                                {props && props.data && props.data['Poll name'] ? <br /> : ""}
                                {props && props.data && props.data['Poll name'] ? props.data['Poll name'] : ""}
                                {props && props.data && props.data['Poll ID'] ? " - "+props.data['Poll ID'] : ""}
                            </div>
                            <div style={{display:'table-cell', width:'40px', paddingLeft:'10px'}}>
                                <CChartPie style={{width:'40px', height:'40px'}}
                                    datasets={[
                                        {
                                            backgroundColor: candidateColors,
                                            data: candidateVotes,
                                            borderWidth: 0
                                        }
                                    ]}
                                    labels={[]}
                                    options={{
                                        layout: {
                                            padding: {
                                                top:-8,
                                                bottom:2,
                                                left:2,
                                                right:2
                                            },
                                            stroke: {
                                                width: 0
                                            }    
                                        },
                                        tooltips: {
                                            enabled: false
                                        },
                                        animation: {
                                            animateRotate: false
                                        },
                                        reponsive: false,
                                        maintainAspectRatio: false
                                    }}
                                />
                            </div>
                    </div>
                </button>           
                : 
                <div style={{width:'300px', height:'100%', padding:'5px'}}>
                <button onClick={(event) => {
                    setDialogOpen(false);
                }} style={{position:'absolute',top:'0px',right:'0px'}}>✖</button>                    
                        
                            <div style={{width:'280px'}}>
                                {props && props.data && props.data['Riding Name'] ? ridingName ? ridingName : "" : ""}
                                {props && props.data && props.data['Poll ID'] ? " - Poll ID: "+props.data['Poll ID'] : ""}
                                {props && props.data && props.data['Poll name'] ? " ("+props.data['Poll name']+ ")" : ""}
                            </div>
                            <div style={{margin:'0 auto', position:'relative', height:'200px', marginTop:'10px'}}>
                            <CTabs>
                                <CNav variant="tabs">
                                    <CNavItem>
                                    <CNavLink>
                                        Votes
                                    </CNavLink>
                                    </CNavItem>
                                    <CNavItem>
                                    <CNavLink>
                                        Turnout
                                    </CNavLink>
                                    </CNavItem>
                                </CNav>
                                <CTabContent>
                                    <CTabPane>
                                        <CChartPie style={{height:'150px',marginTop:'10px'}}
                                            datasets={[
                                                {
                                                    backgroundColor: candidateColors,
                                                    data: candidateVotes,
                                                    borderWidth: 0
                                                }
                                            ]}
                                            labels={candidateNames ? candidateNames : []}
                                            options={{
                                                legend: {
                                                    position:'left',
                                                    labels: {
                                                        boxWidth: 12,
                                                        fontSize: 8,
                                                        padding: 8
                                                    }
                                                },
                                                layout: {
                                                    padding: {
                                                        top:0,
                                                        bottom:2,
                                                        left:2,
                                                        right:2
                                                    },
                                                    stroke: {
                                                        width: 0
                                                    }    
                                                },
                                                tooltips: {
                                                    enabled: true
                                                },
                                                animation: {
                                                    animateRotate: false
                                                },
                                                reponsive: false,
                                                maintainAspectRatio: false
                                            }}
                                        />
                                    </CTabPane>
                                    <CTabPane>
                                    <CChartPie style={{height:'150px',marginTop:'10px'}}
                                            datasets={[
                                                {
                                                    backgroundColor: turnoutColors,
                                                    data: turnoutData,
                                                    borderWidth: 0
                                                }
                                            ]}
                                            labels={turnoutLabels ? turnoutLabels : []}
                                            options={{
                                                legend: {
                                                    position:'left',
                                                    labels: {
                                                        boxWidth: 12,
                                                        fontSize: 8,
                                                        padding: 8
                                                    }
                                                },
                                                layout: {
                                                    padding: {
                                                        top:0,
                                                        bottom:2,
                                                        left:2,
                                                        right:2
                                                    },
                                                    stroke: {
                                                        width: 0
                                                    }    
                                                },
                                                tooltips: {
                                                    enabled: true
                                                },
                                                animation: {
                                                    animateRotate: false
                                                },
                                                reponsive: false,
                                                maintainAspectRatio: false
                                            }}
                                        />                                    
                                    </CTabPane>
                                    <CTabPane>
                                    
                                    </CTabPane>
                                </CTabContent>
                            </CTabs>                                
                                
                            </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default GraphControl;